import { render, staticRenderFns } from "./video.vue?vue&type=template&id=27ee41fc&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=27ee41fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee41fc",
  null
  
)

export default component.exports